import * as React from 'react';
import {useState} from 'react';
import {not} from 'ramda';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import {result} from '../../../lib/result';
import {ArrowLeft, Delete, Ok} from '../../common/btns';

const headerCss = require('../../common/header.css').default;
const css = require('./editor.css').default;

type member = {
    name: string,
    email: string,
    isAdmin: boolean,
}

export default function ({defaultValue, onDone, onCancel, onDel}: {
    defaultValue: member | null,
    onDone: (member: member) => void,
    onCancel: () => void,
    onDel?: () => void,
}) {
    const [name, setName] = useState(defaultValue?.name || '');
    const [email, setEmail] = useState(defaultValue?.email || '');
    const [isAdmin, setIsAdmin] = useState(defaultValue?.isAdmin || false);

    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={onCancel}/>
            <div>編輯權限</div>
            <div className='space'></div>
            {onDel ? <Delete width={25} height={25} onClick={onDel}/> : <></>}
            <Ok width={30} height={30} color='green' onClick={() => {
                const res = check({name, email, isAdmin});
                if (result.ok(res)) {
                    onDone(res[1]);
                } else {
                    alert(res[0]);
                }
            }}/>
        </div>
        <div id={css.body}>
            <Form.Group>
                <Form.Label>姓名</Form.Label>
                <Form.Control placeholder="姓名" value={name} onChange={e => setName(e.target.value)}/>
            </Form.Group>
            <Form.Group>
                <Form.Label>gmail 帳號</Form.Label>
                <Form.Control placeholder="gmail 帳號" value={email} onChange={e => setEmail(e.target.value)}/>
                <Toast bg={'Warning'.toLowerCase()}>
                    <Toast.Header closeButton={false}>
                        說明
                    </Toast.Header>
                    <Toast.Body>
                        請填寫 google 的 gmail 帳號作為登入之用!!
                    </Toast.Body>
                </Toast>
            </Form.Group>
            <Form.Group>
                <Form.Check type='checkbox' label='管理員' id='chk-admin'
                    checked={isAdmin} onChange={e => setIsAdmin(e.target.checked)}/>
            </Form.Group>
        </div>
    </>);
}

function check(member: member): result<member> {
    const name = member.name.trim();
    const email = member.email.trim();
    if (name && email) {
        if (not(email.endsWith('@gmail.com'))) {
            return ['請填寫 google 的 gmail 帳號', null];
        } else {
            return [null, {...member, name, email}];
        }
    } else {
        return ['姓名及 gmail 帳號都要填寫', null];
    }
}
